// 1. Usiamo gli URL completi per far capire al browser dove scaricare Firebase
import { initializeApp } from "https://www.gstatic.com/firebasejs/10.11.0/firebase-app.js";
import { getFirestore } from "https://www.gstatic.com/firebasejs/10.11.0/firebase-firestore.js";

 // Your web app's Firebase configuration
  const firebaseConfig = {
    apiKey: "AIzaSyDFc-c111aMACkj7D1hEOGHvCSrQWIX2ZQ",
    authDomain: "poster-ai-shop.firebaseapp.com",
    projectId: "poster-ai-shop",
    storageBucket: "poster-ai-shop.firebasestorage.app",
    messagingSenderId: "222261228362",
    appId: "1:222261228362:web:d376a386637e5335d507b3"
  };


// 3. Inizializziamo l'app e il database NoSQL (Firestore) [cite: 12]
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

// 4. Rendiamo 'db' disponibile globalmente nel tema Shopify
window.db = db;

console.log("🔥 Firebase Firestore è connesso e pronto!");